<template>
<div >
  <div class="row">
    <Subareas :value="value" class="col" />
  </div>
</div>
</template>

<script>
import Subareas from './components/Subareas'
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    Subareas
  }
}
</script>
